import { useCallback } from "react";

import { useAppDispatch, useAppStore } from "app/redux-store-interactions";
import { orthoCamActions } from "features/orthoCam";
import { pointLineActions, selectCurrentPointLine, selectDraggingPoint } from "features/pointLine";
import { Picker, renderActions, selectPicker } from "features/render";
import { selectIsProcoreDesign } from "slices/explorer";

import { useCancelCurrentModeChanges } from "../features/toolMode/useCancelCurrentModeChanges";

export const PICKER_ESC_TYPES = [
    Picker.Area,
    Picker.ClippingPlane,
    Picker.Measurement,
    Picker.OutlineLaser,
    Picker.PointLine,
    Picker.Manhole,
    Picker.CrossSection,
    Picker.JiraIssuePosition,
    Picker.Coordinates,
    Picker.Dimension,
    Picker.FollowPathObject,
    Picker.SectionPlane,
    Picker.ObjectMeasurement,
];

/**
 * Returns a callback that handles Escape key behaviour for active pickers:
 * - PointLine: cancels drag, starts a new line, or exits to Object picker
 * - All other picker types: exits to Object picker and clears the cross-section point
 */
export function useHandlePickerEsc() {
    const dispatch = useAppDispatch();
    const store = useAppStore();
    const cancelCurrentModeChanges = useCancelCurrentModeChanges();

    return useCallback(() => {
        const state = store.getState();
        const picker = selectPicker(state);
        const currentPointLine = selectCurrentPointLine(state);
        const isDraggingPoint = Boolean(selectDraggingPoint(state));
        const isProcoreDesign = selectIsProcoreDesign(state);

        if (picker === Picker.PointLine) {
            if (isDraggingPoint) {
                dispatch(pointLineActions.setDraggingPoint(null));
            } else if (currentPointLine.points.length > 0) {
                dispatch(pointLineActions.newPointLine());
            } else if (isProcoreDesign) {
                cancelCurrentModeChanges();
            } else {
                dispatch(renderActions.setPicker(Picker.Object));
            }
            return true;
        }

        if (PICKER_ESC_TYPES.includes(picker) && !isProcoreDesign) {
            dispatch(renderActions.setPicker(Picker.Object));
            dispatch(orthoCamActions.setCrossSectionPoint(undefined));
            return true;
        }

        return cancelCurrentModeChanges();
    }, [dispatch, store, cancelCurrentModeChanges]);
}
